export default __webpack_public_path__ + "static/media/img7.0813d5db.jpg";